import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-2427617b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-inverse navbar-fixed-top" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"navbar-header\" data-v-2427617b><button type=\"button\" class=\"navbar-toggle collapsed m-navbar-btn\" data-toggle=\"collapse\" data-target=\"#bs-example-navbar-collapse-1\" aria-expanded=\"false\" data-v-2427617b><span class=\"sr-only\" data-v-2427617b>Toggle navigation</span><span class=\"icon-bar\" data-v-2427617b></span><span class=\"icon-bar\" data-v-2427617b></span><span class=\"icon-bar\" data-v-2427617b></span></button><a href=\"/\" data-v-2427617b><img src=\"" + _imports_0 + "\" class=\"m-logo\" data-v-2427617b></a></div>", 1)
const _hoisted_4 = {
  class: "collapse navbar-collapse",
  id: "bs-example-navbar-collapse-1"
}
const _hoisted_5 = { class: "nav navbar-nav navbar-right" }
const _hoisted_6 = ["href"]

import { withDefaults } from "vue";
import type { Header } from "@/types";

interface HeaderProps {
  data: Header;
  activeIndex: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    data: null,
    activeIndex: { default: 0 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (anchor, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass({ active: __props.activeIndex === index }),
                key: index
              }, [
                _createElementVNode("a", {
                  href: anchor.href,
                  target: "_blank"
                }, _toDisplayString(anchor.text), 9, _hoisted_6)
              ], 2))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})